import UK from "./phpUK";
import DK from "./phpDK";

const phpLangs = {
	EN: UK,
	DK
};
export default phpLangs;


// WEBPACK FOOTER //
// ./src/components/langs/phpIndex.js